export const scUniqueCitys = [
    {
     "SC_Unique_City": "Vijayawada"
    },
    {
     "SC_Unique_City": "Gudivada"
    },
    {
     "SC_Unique_City": "Machilipatnam"
    },
    {
     "SC_Unique_City": "Eluru"
    },
    {
     "SC_Unique_City": "Kurnool"
    },
    {
     "SC_Unique_City": "Anantapur"
    },
    {
     "SC_Unique_City": "Amalapuram"
    },
    {
     "SC_Unique_City": "Kakinada"
    },
    {
     "SC_Unique_City": "Palakol"
    },
    {
     "SC_Unique_City": "Rajahmundry"
    },
    {
     "SC_Unique_City": "Razole"
    },
    {
     "SC_Unique_City": "Tuni"
    },
    {
     "SC_Unique_City": "Chittoor"
    },
    {
     "SC_Unique_City": "Kadapa"
    },
    {
     "SC_Unique_City": "Madanapalle"
    },
    {
     "SC_Unique_City": "Tirupathi"
    },
    {
     "SC_Unique_City": "Nellore"
    },
    {
     "SC_Unique_City": "Ongole"
    },
    {
     "SC_Unique_City": "Visakhapatnam"
    },
    {
     "SC_Unique_City": "Addanki"
    },
    {
     "SC_Unique_City": "Bapatla"
    },
    {
     "SC_Unique_City": "Chilakaluripet"
    },
    {
     "SC_Unique_City": "Guntur"
    },
    {
     "SC_Unique_City": "Tenali"
    },
    {
     "SC_Unique_City": "Narasaraopet"
    },
    {
     "SC_Unique_City": "Piduguralla"
    },
    {
     "SC_Unique_City": "Repalle"
    },
    {
     "SC_Unique_City": "Bengaluru"
    },
    {
     "SC_Unique_City": "Delhi"
    },
    {
     "SC_Unique_City": "Meham"
    },
    {
     "SC_Unique_City": "Palwal"
    },
    {
     "SC_Unique_City": "Rewari"
    },
    {
     "SC_Unique_City": "Kolkata"
    },
    {
     "SC_Unique_City": "Hyderabad"
    },
    {
     "SC_Unique_City": "Jaipur"
    },
    {
     "SC_Unique_City": "Ballari"
    },
    {
     "SC_Unique_City": "Gangavathi"
    },
    {
     "SC_Unique_City": "Hospet"
    },
    {
     "SC_Unique_City": "Hubli"
    },
    {
     "SC_Unique_City": "Mandya"
    },
    {
     "SC_Unique_City": "Raichur"
    },
    {
     "SC_Unique_City": "Sindhanur"
    },
    {
     "SC_Unique_City": "Kodad"
    },
    {
     "SC_Unique_City": "Kukatpally"
    },
    {
     "SC_Unique_City": "Bhopal"
    },
    {
     "SC_Unique_City": "Indore"
    },
    {
     "SC_Unique_City": "Aurangabad"
    },
    {
     "SC_Unique_City": "Mehdipatnam"
    },
    {
     "SC_Unique_City": "Mumbai"
    },
    {
     "SC_Unique_City": "Pune"
    },
    {
     "SC_Unique_City": "Jalandhar"
    },
    {
     "SC_Unique_City": "Moga"
    },
    {
     "SC_Unique_City": "Coimbatore"
    },
    {
     "SC_Unique_City": "Erode"
    },
    {
     "SC_Unique_City": "Hosur"
    },
    {
     "SC_Unique_City": "Chennai"
    },
    {
     "SC_Unique_City": "Karur"
    },
    {
     "SC_Unique_City": "Namakkal"
    },
    {
     "SC_Unique_City": "Salem"
    },
    {
     "SC_Unique_City": "Tiruppur"
    },
    {
     "SC_Unique_City": "Trichy"
    },
    {
     "SC_Unique_City": "Velachery"
    },
    {
     "SC_Unique_City": "Agra"
    },
    {
     "SC_Unique_City": "Firozabad"
    },
    {
     "SC_Unique_City": "Lucknow"
    },
    {
     "SC_Unique_City": "Meerut"
    },
    {
     "SC_Unique_City": "Muzaffarnagar"
    },
    {
     "SC_Unique_City": "Patna"
    }
   ]